import React from 'react';
import { Beer, Wheat, ExternalLink } from 'lucide-react';

const BardasciaModern = () => {
  return (
    <section id="birra" className="py-24 bg-gradient-to-br from-amber-50 to-orange-50">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <div className="text-center mb-16">
            <div className="inline-block px-6 py-2 bg-amber-100 rounded-full mb-4">
              <span className="text-amber-800 font-semibold uppercase tracking-wide text-sm">Le Nostre Birre</span>
            </div>
            <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Bebas Neue, sans-serif' }}>
              La Bardascia
            </h2>
            <p className="text-xl text-gray-600">
              La prima birra narnese ai grani antichi
            </p>
            <div className="w-24 h-1 bg-amber-600 mx-auto rounded-full mt-6"></div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Left - Beer Image */}
            <div className="relative flex justify-center">
              <div className="relative">
                {/* Circular glow background */}
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-80 h-80 rounded-full bg-gradient-to-br from-amber-200 to-orange-200 opacity-50 blur-3xl"></div>
                </div>
                <img
                  src="https://customer-assets.emergentagent.com/job_grano-v2/artifacts/oumnf1n0_IMG_5051.JPG.jpeg"
                  alt="La Bardascia - Birra Grano e Sale"
                  className="relative w-full max-w-md rounded-2xl shadow-2xl transform hover:scale-105 transition-transform duration-500"
                />
              </div>
            </div>

            {/* Right - Content */}
            <div className="space-y-6">
              {/* Badge */}
              <div className="inline-block px-6 py-3 bg-gradient-to-r from-amber-500 to-orange-500 text-white rounded-full shadow-lg">
                <div className="flex items-center space-x-2">
                  <Wheat size={20} />
                  <span className="font-bold">Ai Grani Antichi</span>
                </div>
              </div>

              <h3 className="text-4xl font-bold text-gray-900" style={{ fontFamily: 'Bebas Neue, sans-serif' }}>
                Birra Artigianale Narnese
              </h3>

              <p className="text-lg text-gray-700 leading-relaxed">
                La prima birra narnese ai grani antichi, perfetta per tutti i palati. 
                Tipologia <strong>blanche</strong> di colore biondo chiaro. 
                Al palato risulta <strong>fresca e dissetante</strong>.
              </p>

              {/* Specs */}
              <div className="grid grid-cols-3 gap-4">
                <div className="bg-white rounded-xl p-4 text-center shadow-md">
                  <p className="text-sm text-gray-600 mb-1">Tipo</p>
                  <p className="text-lg font-bold text-gray-900">Blanche</p>
                </div>
                <div className="bg-white rounded-xl p-4 text-center shadow-md">
                  <p className="text-sm text-gray-600 mb-1">Gradazione</p>
                  <p className="text-lg font-bold text-amber-600">4.7% alc</p>
                </div>
                <div className="bg-white rounded-xl p-4 text-center shadow-md">
                  <p className="text-sm text-gray-600 mb-1">Colore</p>
                  <p className="text-lg font-bold text-gray-900">Biondo</p>
                </div>
              </div>

              {/* Features */}
              <div className="bg-white rounded-xl p-6 shadow-md">
                <div className="space-y-3">
                  {[
                    'Prodotta con grani antichi umbri',
                    'Processo di birrificazione artigianale',
                    'Perfetta da abbinare ai nostri piatti',
                  ].map((feature, index) => (
                    <div key={index} className="flex items-center space-x-3">
                      <div className="w-2 h-2 bg-amber-500 rounded-full"></div>
                      <span className="text-gray-700">{feature}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* CTA */}
              <a
                href="https://f9vvvv5kmoeqspr7aqgpyobkuwn6tcl1.pages.pienissimo.pro/home?name=%F0%9F%93%9A"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center space-x-2 px-8 py-4 bg-gradient-to-r from-amber-600 to-orange-600 text-white rounded-full font-semibold hover:from-amber-700 hover:to-orange-700 transition-all duration-300 hover:scale-105 shadow-lg"
              >
                <Beer size={20} />
                <span>Scopri la Carta Birre</span>
                <ExternalLink size={18} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BardasciaModern;
